import React, { useEffect, useRef, useState } from 'react'
import { Card, Col, Form, Row } from 'react-bootstrap'
import LabelCustom from '../../label-custom'
import { Controller } from 'react-hook-form'
import UseProvinces from '../../../hooks/use-adds-provinces'
import UseDistricts from '../../../hooks/use-adds-districts'
import UseSubdistricts from '../../../hooks/use-adds-subdistricts'
import UseErTypes from '../../../hooks/use-er-type'
import InputPhone from '../../input-phone'
import useNumberInput from '../../../helper/input-fix-num'
import AutocompleteCustom from '../../custom/autocomplete'

function Emergency({ control, data, setValue, errors, setError }) {
  const [provincId, setProvincId] = useState(0)
  const [districtId, setDistrictId] = useState(0)
  const provinces = UseProvinces()
  const districts = UseDistricts(provincId)
  const subDistricts = UseSubdistricts(districtId)
  const erTypes = UseErTypes()
  const inputRef = useRef(null)
  const handleKeyDownNum = useNumberInput(inputRef)

  useEffect(() => {
    if (data) {
      setValue('erName', data.er_name)
      setError('erName', data.er_name)

      setValue('erMobilePhone', data.er_phone)
      setError('erMobilePhone', data.er_phone)

      setValue('erAddress', data.er_address)
      setError('erAddress', data.er_address)
    }
  }, [data, setError, setValue])
  useEffect(() => {
    if (data && data.er_relation_id != null) {
      // er_relation_id resolve มาจาก backend แล้ว (mapRelationToId ตอน /recruits/details)
      // เพราะ relation ดิบจาก recruit เป็น text อิสระ พิมพ์อะไรก็ได้ เทียบ label ตรงๆ ไม่ได้
      const erTypesNew = erTypes.find((d) => d.value === data.er_relation_id)

      erTypesNew && setValue('erRelationId', erTypesNew)
    }
  }, [data, erTypes, setError, setValue])
  return (
    <Card border="0">
      <Card.Body>
        <h5 className="mb-3 fw-bold">
          บุคคลติดต่อฉุกเฉิน
          <span className=" ms-2" style={{ color: '#fec203' }}>
            (ถ้ามี)
          </span>
        </h5>
        <Row style={{ rowGap: '15px' }}>
          <Col xl={4}>
            <LabelCustom text={'ชื่อ-สกุล'} />

            <Controller
              name={'erName'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  maxLength={300}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.erName?.message && (
              <span className="text-danger small ">
                {errors.erName.message}
              </span>
            )}
          </Col>

          <Col xl={4}>
            <LabelCustom text={'ความสัมพันธ์'} />
            <Controller
              name={'erRelationId'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <AutocompleteCustom
                  isClearable={true}
                  options={erTypes}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.erRelationId?.message && (
              <span className="text-danger small ">
                {errors.erRelationId.message}
              </span>
            )}
          </Col>
          <Col xl={4}>
            <LabelCustom text={'เบอร์โทรศัพท์'} />

            <Controller
              name={'erMobilePhone'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <InputPhone value={value} onChange={onChange} />
              )}
            />
            {errors.erMobilePhone?.message && (
              <span className="text-danger small ">
                {errors.erMobilePhone.message}
              </span>
            )}
          </Col>
          <Col xl={4}>
            <LabelCustom text={'ที่อยู่'} />

            <Controller
              name={'erAddress'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  maxLength={300}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.erAddress?.message && (
              <span className="text-danger small ">
                {errors.erAddress.message}
              </span>
            )}
          </Col>

          <Col xl={4}>
            <LabelCustom text={'จังหวัด'} />

            <Controller
              name={'erProvince'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <AutocompleteCustom
                  isClearable={true}
                  options={provinces}
                  value={value}
                  onChange={(d) => {
                    onChange(d)

                    setProvincId(d?.value)
                    setDistrictId(0)
                    setValue('erDistric', null)
                    setValue('erSubDistric', null)
                  }}
                />
              )}
            />
            {errors.erProvince?.message && (
              <span className="text-danger small ">
                {errors.erProvince.message}
              </span>
            )}
          </Col>
          <Col xl={4}>
            <LabelCustom text={'อำเภอ/เขต'} />

            <Controller
              name={'erDistric'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <AutocompleteCustom
                  isClearable={true}
                  disabled={provincId > 0 ? false : true}
                  options={districts}
                  value={value}
                  onChange={(d) => {
                    onChange(d)

                    setDistrictId(d?.value)

                    setValue('erSubDistric', null)
                  }}
                />
              )}
            />
            {errors.erDistric?.message && (
              <span className="text-danger small">
                {errors.erDistric.message}
              </span>
            )}
          </Col>
          <Col xl={4}>
            <LabelCustom text={'ตำบล/แขวง'} />

            <Controller
              name={'erSubDistric'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <AutocompleteCustom
                  isClearable={true}
                  disabled={districtId > 0 ? false : true}
                  options={subDistricts}
                  value={value}
                  onChange={(d) => {
                    onChange(d)
                    setValue('erPostCode', d.code)
                  }}
                />
              )}
            />
            {errors.erSubDistric?.message && (
              <span className="text-danger small">
                {errors.erSubDistric.message}
              </span>
            )}
          </Col>
          <Col xl={4}>
            <LabelCustom text={'รหัสไปรษณีย์'} />

            <Controller
              name={'erPostCode'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  maxLength={300}
                  value={value}
                  onChange={onChange}
                  // onKeyDown={handleKeyDownNum}
                />
              )}
            />
            {errors.erPostCode?.message && (
              <span className="text-danger small">
                {errors.erPostCode.message}
              </span>
            )}
          </Col>
          <Col xl={4}>
            <LabelCustom text={'หมายเลขโทรศัพท์บ้าน'} />

            <Controller
              name={'erHomePhone'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  maxLength={300}
                  value={value}
                  onChange={onChange}
                  onKeyDown={handleKeyDownNum}
                />
              )}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  )
}

export default Emergency
